import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import style from "./style";
import { LoadingButton } from "@mui/lab";
import Modal from "../../components/Modal";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
const ContributionPage = ({
  // handleAllowance,
  contribution,
  loading,
  handleFringe,
  handleCreateFringe,
  handleDeleteFringe
  // setOpen,
  // setIsPaid,
  // isPaid,
  // updateLeaveType,
  // handleFringe,
}) => {
  const [allowanceText,setAllowanceText]=useState("")
  const [from, setFrom] = useState("");
  const [leave, setLeave] = useState("");
  const [open, setOpen] = useState(false);
  const [isPaid,setIsPaid]=useState(false)
  const [value, setValue] = useState();
  const [dltAllowance, setDelAllowance] = useState(false);
  const [allowanceTax, setAllowanceTax] = useState(false);
  const handleAddLeaveType = () => {
    setOpen(true);
    setFrom("create");
    setLeave("");
  };
  
  const deleteData = (item) => {
    setValue(item)
  }
  
  
  const handleDeleteItem = () => {
    handleDeleteFringe(value);
    setDelAllowance(false);
  };

  const handleTaxChange = (id) => {
    setAllowanceTax((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleInputChange = (id, value) => {
    setAllowanceText((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  console.log(allowanceTax,"allowanceTax---")
  
  return (
    <>
      <>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 ,mt:3,ml:3,mr:2}}>
          <Typography sx={style.gridText}>Contribution</Typography>
          <Button
            variant="contained"
            type="submit"
            color="success"
            sx={style.jobButtons}
            onClick={handleAddLeaveType}
          >
             + Add
          </Button>
        </Box>
        <Grid container sx={style.mainContainer}>
          {contribution?.map((contributionItem, index) => (
            <Grid item xs={12} lg={3.5} sx={style.gridbox} key={index}>
              <Grid container sx={style.gridContiner}>
                <Grid item xs={12}>
                  <Box sx={style.inputSection}>
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
                      <InputLabel sx={style.labels}>Contribution</InputLabel>
                      <DeleteOutlineIcon 
                        sx={{ ...style.delete, display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer", color: "#ff0000"  }}
                        onClick={() => { deleteData(contributionItem?._id); setDelAllowance(true); }}
                      />
                    </Box>
                    <Box sx={style.selectGrid}>
                      <TextField
                        size="small"
                        name="contribution"
                        value={allowanceText[contributionItem._id] ?? contributionItem.name} 
                        onChange={(e) => handleInputChange(contributionItem._id, e.target.value)}
                        sx={{ width: "100%", maxWidth: "280px" }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ ...style.inputSection, mb: 0.5 }}>
                    <FormControlLabel
                      sx={style.formControlLabel}
                      control={<Checkbox size="small"/>}
                      defaultChecked={contributionItem?.isTaxable}
                      checked={allowanceTax[contributionItem._id] ?? contributionItem?.isTaxable}
                      onChange={() => handleTaxChange(contributionItem._id)}
                      label="Is Taxable" />
                  </Box>
                </Grid>
                <Box sx={{ ...style.btnSection, width: "100%", mt: 0.5 }}>
                  <LoadingButton
                    variant="contained"
                    size="small"
                    disabled={
                      (!allowanceText[contributionItem._id]?.trim() || 
                      (allowanceText[contributionItem._id] ?? contributionItem.name) === contributionItem.name) && 
                      (allowanceTax[contributionItem._id] ?? contributionItem.isTaxable) === contributionItem.isTaxable 
                    }
                    onClick={() =>{
                      handleFringe(
                        allowanceText[contributionItem._id] ?? contributionItem.name,
                        allowanceTax[contributionItem._id] ?? contributionItem.isTaxable,
                        contributionItem._id
                      ); setAllowanceText("")} 
                    }
                    type="submit"
                    color="primary"
                    sx={style.submitButton}
                  >
                    Save
                  </LoadingButton>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Modal
          open={open}
          loading={loading}
          setOpen={setOpen}
          btnText={"Add New"}
          title={"contribution Type"}
          handleCheck={() => {
            {handleCreateFringe(leave, isPaid),setOpen(false)}   
          }}
        >
          <Box sx={style.popupBox}>
            <Typography>
              {from === "edit" ? "Add contribution Type" : "Add contribution Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="leave"
              value={leave}
              onChange={(e) => setLeave(e.target.value)}
            />
            <FormControlLabel
              control={<Checkbox />}
              checked={isPaid}
              onChange={(e) => setIsPaid(e.target.checked)}
              label="Is Taxable"
            />
          </Box>
        </Modal>

        <Modal open={dltAllowance} setOpen={setDelAllowance} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete  contribution Type"} handleDelete={handleDeleteItem}>
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
      </>
    </>
  );
};

export default ContributionPage;
